import { getCountryFromLocale, getLanguageFromLocale } from '../locale-parsing'
import { isValidLocale } from '../locale-validation'
import type { Locale } from '../types/locale'

export const convertLocaleToCookieFormat = (locale: Locale) => {
  if (!isValidLocale(locale)) {
    throw new Error(`Invalid locale: ${locale}`)
  }
  return `${getLanguageFromLocale(locale)}_${getCountryFromLocale(locale).toUpperCase()}`
}

export const convertLocaleToCountrySwitchCookieFormat = (locale: Locale) => {
  if (!isValidLocale(locale)) {
    throw new Error(`Invalid locale: ${locale}`)
  }
  return `${getLanguageFromLocale(locale).toUpperCase()}`
}

export const convertLocaleToCommerceGraphQLFormat = (locale: Locale) => {
  if (!isValidLocale(locale)) {
    throw new Error(`Invalid locale: ${locale}`)
  }
  return `${getLanguageFromLocale(locale)}-${getCountryFromLocale(locale).toUpperCase()}`
}

export const convertLocaleToSegmentFormat = (locale: Locale) => {
  if (!isValidLocale(locale)) {
    throw new Error(`Invalid locale: ${locale}`)
  }
  return `${getLanguageFromLocale(locale)}-${getCountryFromLocale(locale)}`.toLowerCase()
}

export const convertCookieFormatToLocale = (cookie: string): Locale => {
  const locale = cookie.replace('_', '-').toLowerCase()
  if (!isValidLocale(locale)) {
    throw new Error(`Invalid locale: ${locale}`)
  }
  return locale
}

export const getCountryCode = (locale: Locale) =>
  getCountryFromLocale(locale).toUpperCase()

export const getTranslatableCountryName = (
  languageCode: string,
  countryCode: string,
) => {
  if (!isValidLocale(`${languageCode}-${countryCode}`)) {
    throw new Error(`Invalid locale: ${languageCode}`)
  }
  const regionNames = new Intl.DisplayNames([languageCode], { type: 'region' })
  return regionNames.of(countryCode.toUpperCase())
}
